/*
 * Branded Best House: the in-hands date on product pages (snippets/bb-house-buy-extras.liquid).
 * The buyer picks the day the pieces must be with them and sees at once the date to approve their proof by
 * (bb-dates.js). The date is saved on the cart as two cart attributes, "In hands by" and "Approve proof by", so it
 * travels to the order Nick receives. Cart attributes are the order's own fields: line-item properties (the logo
 * lines Nick's tool writes) are never touched. Clearing the field clears both attributes.
 * With no date saved yet, the field starts on the earliest date we promise, today + 45 (Nick, 2026-10-28: "Make this
 * 45 days out from today's date always"); that date is saved with the order when the buyer adds to cart, so the order
 * carries the date they saw.
 */
(function () {
  'use strict';
  if (window.bbInhandReady) return;
  window.bbInhandReady = true;

  var D = window.BBDates;
  if (!D) return;

  var ATTR = 'In hands by';
  var ATTR_APPROVE = 'Approve proof by';

  function lineFor(iso) {
    var today = D.todayISO();
    if (!D.parseISO(iso)) {
      return { text: 'If this is event specific, please let us know the day you need it by.', strong: false };
    }
    if (iso < today) return { text: 'That date has already passed. Pick the day it must be with you.', strong: false };
    if (!D.canPromise(iso, today)) {
      return {
        text: 'Sooner than we can promise. Our earliest is about ' + D.fmtDay(D.earliestFrom(iso, today)) +
          '. Your date is saved, and we’ll tell you plainly what’s possible.',
        strong: true
      };
    }
    return {
      text: 'Approve your proof by ' + D.fmtDay(D.approveByDate(iso)) + '.',
      strong: true,
      ok: true
    };
  }

  function show(box, iso) {
    var line = box.querySelector('[data-bbh-inhand-line]');
    if (!line) return;
    var l = lineFor(iso);
    var key = l.text + '|' + (l.extra || '');
    if (line.dataset.key === key) return; // unchanged: don't make screen readers announce it again
    line.dataset.key = key;
    line.textContent = '';
    var main = document.createElement('span');
    main.className = l.strong ? 'bbh-inhand__strong' : '';
    main.textContent = l.text;
    line.appendChild(main);
    if (l.extra) line.appendChild(document.createTextNode(' ' + l.extra));
  }

  // One save at a time, always the newest value: typing a year fires a change per digit ("0002" … "2026").
  var timer = null, inFlight = false, pending = null;
  function queue(box, iso) {
    pending = { box: box, iso: iso };
    clearTimeout(timer);
    timer = setTimeout(flush, 600);
  }
  function flush() {
    if (inFlight || !pending) return;
    var job = pending; pending = null;
    var ok = !!D.parseISO(job.iso);
    if (ok && job.iso < D.todayISO()) return; // a half-typed or past date is never saved
    inFlight = true;
    save(job.box, job.iso, ok).then(function () { inFlight = false; if (pending) flush(); });
  }

  function save(box, iso, ok) {
    var attrs = {};
    attrs[ATTR] = ok ? iso : '';
    attrs[ATTR_APPROVE] = ok && D.canPromise(iso, D.todayISO()) ? D.fmtDate(D.approveByDate(iso)) : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var note = box.querySelector('[data-bbh-inhand-saved]');
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      if (note) note.textContent = ok ? 'Saved with your order.' : '';
    }).catch(function () {
      if (note) note.textContent = ok ? 'We couldn’t save your date. Reply to your order email with it.' : '';
    });
  }

  function init(box) {
    if (box.dataset.bbhReady) return;
    box.dataset.bbhReady = '1';
    var input = box.querySelector('[data-bbh-inhand-input]');
    if (!input) return;
    input.min = D.todayISO();
    if (!input.value) {
      input.value = D.earliestInhand(D.todayISO());
      box.dataset.bbhUnsaved = '1';
    }
    box.hidden = false;
    show(box, input.value);
    input.addEventListener('input', function () { show(box, input.value); });
    input.addEventListener('change', function () {
      delete box.dataset.bbhUnsaved;
      show(box, input.value);
      queue(box, input.value);
    });
  }

  // Add to cart with the starting date untouched: save it once the add is done, so the order carries the date the
  // buyer saw. (Saved alongside the add, on a first visit it raced the cart's creation and was lost.)
  function saveStarting(e) {
    var boxes = document.querySelectorAll('[data-bbh-inhand][data-bbh-unsaved]');
    if (!boxes.length) return;
    ((e && e.promise) || Promise.resolve()).then(function () {
      boxes.forEach(function (box) {
        var input = box.querySelector('[data-bbh-inhand-input]');
        if (!input || !box.dataset.bbhUnsaved) return;
        delete box.dataset.bbhUnsaved;
        pending = { box: box, iso: input.value }; // now, not after the typing pause: the cart page may open next
        flush();
      });
    }, function () {});
  }

  function all() { document.querySelectorAll('[data-bbh-inhand]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:cart:lines-update', saveStarting); // Horizon: an add to cart, with a promise of its result
})();
